export default __webpack_public_path__ + "static/media/srectr-kit-set-02.d3d67224.jpeg";